<template>
    <div class="w-full flex items-center justify-center gap-3 overflow-hidden transition-all duration-300 my-1">
        <div class="h-4 w-4 rounded-full animateCircle" :class="buttonTheme" :style="`--delay: ${index / 10 + 0.3}s`" v-for="circle, index in numberOfCircles" :key="index"></div>
    </div>
</template>

<script setup lang="ts">
    const numberOfCircles = ref(5);
    const route = ref('test');
    const props = defineProps<{
        open: boolean;
    }>()
    onMounted(() => {
        route.value = window.location.origin;
    })
    const buttonTheme = computed(() => {
    if (route.value.includes('nordvaerk')) {
        return 'bg-primary group-hover:bg-white'
    } else if (route.value.includes('bibliotek')) {
        return 'bg-bib group-hover:bg-white'
    } else {
        return 'bg-primary group-hover:bg-white'
    }
});
</script>

<style>
.animateCircle {
    animation: 1.2s ease-in-out var(--delay) infinite loader;
}

@keyframes loader {
    0% {
        opacity: 0.05;
    }
    50% {
        opacity: 1;
    }
    100% {
        opacity: 0.05;
    }
}
</style>